// Client-owned branding and tenant settings.
// This is the ONLY environment file a client branch changes. API hosts and environment
// names live in the other environment files and flow down from master untouched.
export const client = {
  // Shown in the header and as the logo alt text.
  name: 'City of Madeira Beach',
  appName: 'City of Madeira Beach',
  // Set to '' to show the client initials instead of a logo.
  logoUrl: 'assets/img/logo/madeira-beach.png',
  // Tenant key the policies API expects in the x-api-key header. Same value in every environment.
  apiKey: 'lR7@c%g0Vp73sU3i',
  // Datadog RUM. The service name becomes `${datadogServicePrefix}_<env>`.
  datadogServicePrefix: 'policies_madeirabeach',
  datadogProd: {
    clientToken: 'pub4e5b93ea7e9b9269a5f9db1710f71c5b',
    applicationId: '26c1a446-7f3d-47e7-901f-62ad857cd30f',
  },
};
